/**
 * I passi del tutorial guidato delle Statistiche ("Visite del sito").
 *
 * Nessun preparativo: la pagina non ha menu o dialog da aprire. I blocchi dei dati
 * esistono solo quando Google Analytics risponde: se non e' collegato i passi che li
 * riguardano vengono saltati (missing: 'skip').
 */
const at = name => `[data-tour-scope="stats"] [data-tour="${name}"]`;

export function createStatsTourSteps() {
	return [
		{
			body: "Questa pagina mostra il traffico del sito pubblico preso da Google Analytics: quante persone entrano, da dove arrivano, cosa guardano. Non sono le vendite, che stanno nella Home. L'unico numero di vendita qui e' il tasso di conversione, che mette insieme visite e ordini del sito.",
			key: 'intro',
			placement: 'bottom',
			target: at('tutorial'),
			title: 'Visite del sito',
		},
		{
			body: "Come nella Home: scegli mese, trimestre, anno o due date, e con cosa confrontarli (il periodo subito prima o lo stesso periodo dell'anno scorso). Se il periodo e' in corso, il confronto usa lo stesso numero di giorni, cosi' non paragoni 10 giorni con un mese intero.",
			key: 'period',
			placement: 'bottom',
			target: at('period'),
			title: 'Periodo e confronto',
		},
		{
			body: 'Visite mostra il traffico di Google Analytics. Comportamento mostra i numeri di Microsoft Clarity: pagine dove i visitatori cliccano a vuoto, cliccano con rabbia o incontrano errori, con i link alle mappe di calore e alle registrazioni su Clarity.',
			key: 'tabs',
			placement: 'bottom',
			target: at('tabs'),
			title: 'Visite e comportamento',
		},
		{
			body: "I numeri principali. Il chip colorato e' la variazione rispetto al periodo di confronto: verde se migliora, rosso se peggiora, e accanto c'e' il valore di prima. Passa il mouse sulla (i) di ogni riquadro per sapere esattamente cosa conta. Visitatori sono le persone, Visite gli ingressi: chi torna tre volte fa un visitatore e tre visite.",
			key: 'kpis',
			missing: 'skip',
			placement: 'bottom',
			target: at('kpis'),
			title: 'I numeri principali',
		},
		{
			body: "Le visite giorno per giorno (mese per mese sui periodi lunghi). La linea tratteggiata e' il periodo di confronto, allineato giorno con giorno: dove le barre stanno sopra la linea stai andando meglio di prima.",
			key: 'trend',
			missing: 'skip',
			placement: 'top',
			target: at('trend'),
			title: 'Andamento',
		},
		{
			body: "Da dove arrivano i visitatori. 'Per tipo' raggruppa le provenienze (ricerca Google, accesso diretto, social, newsletter, pubblicita'...), 'Per sito' mostra i singoli siti e sorgenti. Utile per capire se una campagna o un post hanno portato gente.",
			key: 'sources',
			missing: 'skip',
			placement: 'left',
			target: at('sources'),
			title: 'Provenienza',
		},
		{
			body: "Le pagine piu' aperte, con il titolo e l'indirizzo. Il tempo medio e' l'attenzione media ogni volta che la pagina viene aperta: una scheda prodotto molto vista ma con pochi secondi e' una pagina da cui la gente scappa.",
			key: 'pages',
			missing: 'skip',
			placement: 'top',
			target: at('pages'),
			title: "Le pagine piu' visitate",
		},
		{
			body: "Su quali schermi guardano il sito: computer, smartphone o tablet. E' il dato da tenere a mente quando si decide come sistemare una pagina.",
			key: 'devices',
			missing: 'skip',
			placement: 'top',
			target: at('devices'),
			title: 'Dispositivi',
		},
		{
			body: "I primi dieci paesi per numero di visitatori, con la variazione rispetto a prima. Se vendi all'estero, qui vedi da dove arriva l'interesse.",
			key: 'countries',
			missing: 'skip',
			placement: 'top',
			target: at('countries'),
			title: 'Paesi',
		},
	];
}
